import { useEffect } from "react";
import BossierCityHeroSection from "./components/HeroSection";
import BossierCityStickyNav from "./components/StickyNav";
import BossierCityProcessingTimeSection from "./components/ProcessingTimeSection";
import BossierCityServicesSection from "./components/ServicesSection";
import BossierCityLocalAreaSection from "./components/LocalAreaSection";
import BossierCityTestimonialsSection from "./components/TestimonialsSection";
import BossierCityAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import BossierCityComparisonSection from "./components/ComparisonSection";
import BossierCityMistakesSection from "./components/MistakesSection";
import BossierCityHowItWorksSection from "./components/HowItWorksSection";
import BossierCityFAQSection, { faqs } from "./components/FAQSection";
import BossierCityHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import BossierCityFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";
import BossierCityTravelTimingSection from "./components/TravelTimingSection";
import BossierCityDestinationsSection from "./components/DestinationsSection";

export default function BossierCityPage() {
  useEffect(() => {
    document.title = "Emergency Passport Bossier City, LA — Expedited Same-Day Service | Fast Passport Center";

    const setMeta = (name: string, content: string) => {
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.setAttribute("name", name); document.head.appendChild(el); }
      el.setAttribute("content", content);
    };
    const setLink = (rel: string, href: string) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) { el = document.createElement("link"); el.setAttribute("rel", rel); document.head.appendChild(el); }
      el.setAttribute("href", href);
    };

    const pageUrl = "https://fastpassportcenter.com/bossier-city/";
    setLink("canonical", pageUrl);
    setMeta("description", "Emergency and expedited passport services in Bossier City, LA — as fast as 24 hours. Serving Barksdale AFB military families, casino industry professionals, and Bossier Parish residents. A+ BBB rated, registered State Dept. courier.");
    setMeta("geo.placename", "Bossier City, Louisiana");
    setMeta("geo.region", "US-LA");
    setMeta("geo.position", "32.5160;-93.7321");
    setMeta("ICBM", "32.5160, -93.7321");

    const graph = [
      { "@type": "BreadcrumbList", itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: "https://fastpassportcenter.com/" },
        { "@type": "ListItem", position: 2, name: "Louisiana", item: "https://fastpassportcenter.com/louisiana/" },
        { "@type": "ListItem", position: 3, name: "Bossier City Passport Services", item: pageUrl },
      ]},
      { "@type": "LocalBusiness", name: "Fast Passport Center", description: "Emergency and expedited passport services for Bossier City, Barksdale AFB, and the Shreveport-Bossier metro.", url: pageUrl, telephone: "+1-877-253-0084", areaServed: { "@type": "City", name: "Bossier City", containedInPlace: { "@type": "State", name: "Louisiana" } }, priceRange: "$$$", openingHours: ["Mo-Fr 09:00-18:00"], aggregateRating: { "@type": "AggregateRating", ratingValue: "4.9", reviewCount: "1200" } },
      { "@type": "FAQPage", mainEntity: faqs.map((faq) => ({ "@type": "Question", name: faq.q, acceptedAnswer: { "@type": "Answer", text: faq.a } })) },
    ];

    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "structured-data-bossier-city";
    document.getElementById("structured-data-bossier-city")?.remove();
    script.textContent = JSON.stringify({ "@context": "https://schema.org", "@graph": graph });
    document.head.appendChild(script);

    return () => {
      document.getElementById("structured-data-bossier-city")?.remove();
      const canonical = document.querySelector('link[rel="canonical"]');
      if (canonical) canonical.remove();
    };
  }, []);

  return (
    <div className="font-sans">
      <BossierCityHeroSection />
      <BossierCityStickyNav />
      <BossierCityProcessingTimeSection />
      <BossierCityServicesSection />
      <BossierCityLocalAreaSection />
      <BossierCityTravelTimingSection />
      <BossierCityDestinationsSection />
      <BossierCityTestimonialsSection />
      <BossierCityAcceptanceFacilitiesSection />
      <BossierCityComparisonSection />
      <BossierCityMistakesSection />
      <BossierCityHowItWorksSection />
      <BossierCityFAQSection />
      <BossierCityHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/bossier-city" state="LA" />
      <BossierCityFinalCTA />
    </div>
  );
}